<template><section><h2>checkbox</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-form :title="'复选框样式展示'">
    <weui-form-control>
      <weui-form-group>
        <weui-checkbox-group name="type" v-model="value" @input="onChange()" :showMore="true">
          <weui-checkbox value="1" label="standard is dealt for u."></weui-checkbox>
          <weui-checkbox value="2" label="standard is dealicient for u."></weui-checkbox>
        </weui-checkbox-group>
      </weui-form-group>
    </weui-form-control>
    <weui-form-tip>
      <template #tipContent>
        点击下一步即表示<a href="javascript:">同意用户协议</a>
      </template>
    </weui-form-tip>
  </weui-form>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-form :title=&quot;'复选框样式展示'&quot;&gt;
    &lt;weui-form-control&gt;
      &lt;weui-form-group&gt;
        &lt;weui-checkbox-group name=&quot;type&quot; v-model=&quot;value&quot; @input=&quot;onChange()&quot; :showMore=&quot;true&quot;&gt;
          &lt;weui-checkbox value=&quot;1&quot; label=&quot;standard is dealt for u.&quot;&gt;&lt;/weui-checkbox&gt;
          &lt;weui-checkbox value=&quot;2&quot; label=&quot;standard is dealicient for u.&quot;&gt;&lt;/weui-checkbox&gt;
        &lt;/weui-checkbox-group&gt;
      &lt;/weui-form-group&gt;
    &lt;/weui-form-control&gt;
    &lt;weui-form-tip&gt;
      &lt;template #tipContent&gt;
        点击下一步即表示&lt;a href=&quot;javascript:&quot;&gt;同意用户协议&lt;/a&gt;
      &lt;/template&gt;
    &lt;/weui-form-tip&gt;
  &lt;/weui-form&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  data(){
    return {
      value: ['2']
    }
  },
  methods: {
    onChange() {
     console.log(this.value)
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<h3>checkbox-group</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>标识符</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value(v-model)</td>
<td>当前选中的值</td>
<td>array</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>showMore</td>
<td>是否显示更多</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>onMore</td>
<td>更多事件回调</td>
<td>function()</td>
</tr>
</tbody>
</table>
<h3>checkbox</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>选项的值</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>label</td>
<td>选项名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data(){
    return {
      value: ['2']
    }
  },
  methods: {
    onChange() {
     console.log(this.value)
    }
  }
};
</script>